import { ActionList, UserLoginData } from '@models/models';

export interface TwoFactorAuthorization {
	account2faSettings: Account2FASettings;
	user2faState: User2FASettings;
}

export interface Account2FASettings {
	actions: ActionList;
}

export interface User2FASettings {
	actions: ActionList;
	configure2faMetadata: {
		actions: ActionList;
		twoFaSecret: string;
	};
}

export interface TwoFaSetupData {
	sixDigitVerificationCode: string;
	secretQuestions: Array<SecretQuestion>;
	enforce2FA: boolean;
}

export interface SecretQuestion {
	question: string;
	answer: string;
}

export interface TwoFaValidationModel {
	isValid: boolean;
	place: 'QUESTIONS' | 'CODE';
}

export interface TwoFaModalControl {
	state: boolean;
	action: 'LOGIN' | 'RESET' | 'SETUP' | 'DISMISS_SETUP' | 'SUCCESS_SETUP';
	payload?: any;
}

export interface TwoFaRecoverData {
	actions: ActionList;
	secretQuestions: Array<RecoverQuestion>;
}

export interface RecoverQuestion {
	id: string;
	question: string;
}

export interface TwoFaRecoverDataToSend {
	questions: Array<RecoverAnswer>;
}

export interface RecoverAnswer {
	id: string;
	answer: string;
}

export interface LoginModalPayload {
	userPayload: UserLoginPayload;
	recoverUser2FA: TwoFaRecoverData;
}

export interface UserLoginPayload {
	userData: UserLoginData;
	authorizationKey: string;
}

export interface AdminTwoFaUserInfo {
	users: Array<UserTwoFaAccountInfo>;
}

export interface UserTwoFaAccountInfo {
	actions: ActionList;
	email: string;
	firstName: string;
	id: number;
	lastName: string;
	sixDigitCode: string;
}

export interface Step {
	number: number;
	label: string;
}

export const Steps: Array<Step> = [
	{ number: 1, label: 'Download App' },
	{ number: 2, label: 'Set Questions' },
	{ number: 3, label: 'Enter Code' }
];

export interface AvailableQuestion {
	question: string;
	selected: boolean;
}

export const SecretQuestions: Array<AvailableQuestion> = [
	{ question: 'What was your childhood nickname?', selected: false },
	{
		question: 'In what city did you meet your spouse/significant other?',
		selected: false
	},
	{
		question: 'What is the name of your favourite childhood friend?',
		selected: false
	},
	{
		question: 'What street did you live on when you were 10 years old?',
		selected: false
	},
	{
		question: "What is your oldest cousin's first and last name?",
		selected: false
	},
	{
		question:
			'What is the first name of the boy or girl that you first kissed?',
		selected: false
	},
	{ question: 'In what city or town did your parents meet?', selected: false },
	{
		question: 'What was the name of your elementary / primary school?',
		selected: false
	},
	{
		question: 'What is the name of the company of your first job?',
		selected: false
	},
	{ question: 'In what city or town was your first job?', selected: false },
	{ question: 'To what city did you go on your honeymoon?', selected: false },
	{ question: 'What was your dream job as a child?', selected: false },
	{ question: 'What was the first concert you attended?', selected: false },
	{ question: "What is your mother's middle name?", selected: false },
	{
		question: 'What was the make and model of your first car?',
		selected: false
	}
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/models/two-fa.models.ts